var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',{staticClass:"copyright",domProps:{"innerHTML":_vm._s(_vm.formattedYear)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }